import { Box } from "@mui/material";
import React from "react";
import Modal from "react-responsive-modal";
import CloseIcon from '@mui/icons-material/Close';

const ModalComp = ({ children, open, onCloseModal, padding, modalheight, modalwidth, closeicon, closeOnEsc }) => {
  return (
    <Modal
      open={open}
      closeOnEsc={closeOnEsc? closeOnEsc:false}
      onClose={onCloseModal}
      showCloseIcon={closeicon ? closeicon :false}
      onOverlayClick={onCloseModal}
      closeIcon={<CloseIcon style={{ fontSize: 24, color: "#ffffff", padding: 4}} />}
      center
      classNames={{
        // overlayAnimationIn: "customEnterOverlayAnimation",
        // overlayAnimationOut: "customLeaveOverlayAnimation",
        // modalAnimationIn: "customEnterModalAnimation",
        // modalAnimationOut: "customLeaveModalAnimation",
      }}
      animationDuration={50}
      styles={{
        modal: {
          width: modalwidth ? modalwidth : "100%",
          padding: "unset",
          overflow: "hidden",
          height: modalheight ? modalheight : "450px",
          borderRadius: "10px",
          zIndex: 9999,
          boxShadow:'none !important',
        },
        overlay: {
          zIndex: 9998,
          background: "rgba(165, 165, 165, 0.7)",
        },
        closeButton: {
          background: "#757575",
          top: '4%',
          right: '4%',
          borderRadius: "50%",
        },
      }}
    >
      <Box padding={typeof padding === "undefined" ? 4 : null} height={"100%"}>
        {children}
      </Box>
    </Modal>
  );
};

export default ModalComp;
